import { v4 as uuidv4 } from 'uuid';
import httpClient from '../../api/http-clients';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

/* -------------------- Utility -------------------- */
export const getCartSessionId = () => {
  let cartSessionID = localStorage.getItem('cartSessionID');
  if (!cartSessionID) {
    cartSessionID = uuidv4();
    localStorage.setItem('cartSessionID', cartSessionID);
  }
  return cartSessionID;
};

/* -------------------- THUNKS -------------------- */

// Fetch cart

// export const fetchCart = createAsyncThunk(
//   'cart/fetchCart',
//   async (_, { getState, rejectWithValue }) => {
//     const state = getState();
//     const userID = state?.user?.data?.userID || state.auth.user?.userID;
//     const { isAuthenticated } = state.auth;
//     const cartSessionID = getCartSessionId();

//     if (isAuthenticated && !userID) {
//       console.error('Authenticated but no userID');
//       return rejectWithValue('No userID found in auth or user state');
//     }

//     try {
//       let response;
//       if (isAuthenticated) {
//         // POST for authorized users with userID as body request
//         const url = `/cart/view-cart`;
//         response = await httpClient.post(url, { userID: userID });
//       } else {
//         // GET for unauthorized users with cartSessionID as query param
//         const url = `/cart/view-cart?cartSessionID=${cartSessionID}`;
//         response = await httpClient.get(url);
//       }

//       if (!response.data?.success) {
//         return rejectWithValue(
//           response.data?.message || 'Failed to fetch cart'
//         );
//       }

//       return response.data;
//     } catch (error) {
//       console.error('view-cart error:', error.response?.data);
//       return rejectWithValue(error.response?.data?.message || error.message);
//     }
//   }
// );
export const fetchCart = createAsyncThunk(
  'cart/fetchCart',
  async (_, { getState, rejectWithValue }) => {
    const state = getState();
    const userID = state?.user?.data?.userID || state.auth.user?.userID;
    const { isAuthenticated } = state.auth;
    const cartSessionID = getCartSessionId();

    if (isAuthenticated && !userID) {
      console.error('Authenticated but no userID');
      return rejectWithValue('No userID found in auth or user state');
    }

    try {
      let response;
      if (isAuthenticated) {
        // POST for authorized users
        response = await httpClient.post(`/cart/view-cart`, { userID });
      } else {
        // GET for unauthorized users
        response = await httpClient.get(
          `/cart/view-cart?cartSessionID=${cartSessionID}`
        );
      }

      if (!response.data?.success) {
        return rejectWithValue(
          response.data?.message || 'Failed to fetch cart'
        );
      }

      const cartData = response.data?.data?.cart;
      if (!cartData?.items) return response.data;

      // ✅ Normalize invalid selectedPaymentPlan
      const normalizedItems = cartData.items.map((item) => {
        const validPlans =
          item.paymentOptionsBreakdown?.map((opt) => opt.type) || [];
        if (!validPlans.includes(item.selectedPaymentPlan)) {
          return { ...item, selectedPaymentPlan: 'full' }; // fallback
        }
        return item;
      });

      // ✅ Rebuild the cart with normalized items
      const normalizedCart = {
        ...cartData,
        items: normalizedItems,
      };

      // ✅ Return same shape as backend but with normalized data
      return {
        ...response.data,
        data: {
          ...response.data.data,
          cart: normalizedCart,
        },
      };
    } catch (error) {
      console.error('view-cart error:', error.response?.data);
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// Clear cart
export const clearCart = createAsyncThunk(
  'cart/clearCart',
  async (_, { getState, rejectWithValue }) => {
    const state = getState();
    const cartSessionID = getCartSessionId();
    const userID = state?.user?.data?.userID || state.auth.user?.userID;
    const { isAuthenticated } = state.auth;

    try {
      const response = await httpClient.post('/cart/clear-cart', {
        [isAuthenticated ? 'userID' : 'cartSessionID']: isAuthenticated
          ? userID
          : cartSessionID,
      });
      if (!response.data?.success) {
        return rejectWithValue(
          response.data?.message || 'Failed to clear cart'
        );
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// Retry fetch cart with delay
export const retryFetchCart = createAsyncThunk(
  'cart/retryFetchCart',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      // Add a 500ms delay to account for potential backend persistence delay
      await new Promise((resolve) => setTimeout(resolve, 500));
      const response = await dispatch(fetchCart()).unwrap();
      return response;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to retry fetch cart');
    }
  }
);

// Add to cart with default payment plan
// export const addToCart = createAsyncThunk(
//   'cart/addToCart',
//   async (product, { getState, dispatch, rejectWithValue }) => {
//     const prevCart = [...getState().cart.cart];
//     // const selectedPaymentPlan = getState().cart.selectedPaymentPlan;
//     const selectedPaymentPlan =
//       product.selectedPaymentPlan ||
//       getState().cart.selectedPaymentPlan ||
//       'monthly';

//     let paymentOptions = [];
//     try {
//       paymentOptions = JSON.parse(product.paymentOptionsBreakdown || '[]');
//     } catch (error) {}

//     // Find the selected payment plan details
//     const paymentPlanDetails = paymentOptions.find(
//       (option) => option.type === selectedPaymentPlan
//     ) || {
//       type: selectedPaymentPlan,
//       amount: product.fairAppPrice || product.productPrice,
//       totalPrice: product.fairAppPrice || product.productPrice,
//     };

//     const normalizedProduct = {
//       ...product,
//       quantity: product.quantity || 1,
//       paymentOptionsBreakdown: selectedPaymentPlan,
//       selectedPaymentPlanDetails: {
//         type: selectedPaymentPlan,
//         amount: Number(
//           paymentPlanDetails.amount ||
//             product.fairAppPrice ||
//             product.productPrice
//         ),
//         totalPrice:
//           Number(
//             paymentPlanDetails.amount ||
//               product.fairAppPrice ||
//               product.productPrice
//           ) * (product.quantity || 1),
//       },
//       price: Number(
//         paymentPlanDetails.amount ||
//           product.fairAppPrice ||
//           product.productPrice
//       ),
//       totalPrice:
//         Number(
//           paymentPlanDetails.amount ||
//             product.fairAppPrice ||
//             product.productPrice
//         ) * (product.quantity || 1),
//     };

//     // Optimistic update
//     dispatch(cartSlice.actions.optimisticAdd(normalizedProduct));

//     try {
//       const response = await httpClient.post('/cart/add-to-cart', {
//         productID: product.productID,
//         quantity: normalizedProduct.quantity,
//         cartSessionID: getCartSessionId(),
//         selectedPaymentPlan,
//       });

//       // Sync with backend
//       const fetchResult = await dispatch(fetchCart()).unwrap();
//       // If fetchCart returns empty, retry once
//       if (!fetchResult.data?.cart?.items?.length) {
//         await dispatch(retryFetchCart()).unwrap();
//       }
//       return fetchResult;
//     } catch (error) {
//       dispatch(cartSlice.actions.rollback(prevCart));
//       return rejectWithValue(error.message || 'Failed to add to cart');
//     }
//   }
// );
export const addToCart = createAsyncThunk(
  'cart/addToCart',
  async (product, { getState, dispatch, rejectWithValue }) => {
    const prevCart = [...getState().cart.cart];

    //  Use product’s plan if it exists, else fallback to Redux or 'monthly'
    const selectedPaymentPlan =
      product.selectedPaymentPlan ||
      getState().cart.selectedPaymentPlan ||
      'monthly';

    let paymentOptions = [];
    try {
      paymentOptions = JSON.parse(product.paymentOptionsBreakdown || '[]');
    } catch (error) {}

    //  Get correct plan details
    const paymentPlanDetails = paymentOptions.find(
      (option) => option.type === selectedPaymentPlan
    ) || {
      type: selectedPaymentPlan,
      amount: product.fairAppPrice || product.productPrice,
      totalPrice: product.fairAppPrice || product.productPrice,
    };

    const normalizedProduct = {
      ...product,
      quantity: product.quantity || 1,
      paymentOptionsBreakdown: selectedPaymentPlan,
      selectedPaymentPlanDetails: {
        type: selectedPaymentPlan,
        amount: Number(
          paymentPlanDetails.amount ||
            product.fairAppPrice ||
            product.productPrice
        ),
        totalPrice:
          Number(
            paymentPlanDetails.amount ||
              product.fairAppPrice ||
              product.productPrice
          ) * (product.quantity || 1),
      },
      price: Number(
        paymentPlanDetails.amount ||
          product.fairAppPrice ||
          product.productPrice
      ),
      totalPrice:
        Number(
          paymentPlanDetails.amount ||
            product.fairAppPrice ||
            product.productPrice
        ) * (product.quantity || 1),
      selectedPaymentPlan,
    };

    // Optimistic update
    dispatch(cartSlice.actions.optimisticAdd(normalizedProduct));

    try {
      const response = await httpClient.post('/cart/add-to-cart', {
        productID: product.productID,
        quantity: normalizedProduct.quantity,
        cartSessionID: getCartSessionId(),
        selectedPaymentPlan,
      });

      const fetchResult = await dispatch(fetchCart()).unwrap();
      if (!fetchResult.data?.cart?.items?.length) {
        await dispatch(retryFetchCart()).unwrap();
      }
      return fetchResult;
    } catch (error) {
      dispatch(cartSlice.actions.rollback(prevCart));
      return rejectWithValue(
        error.response?.data?.message || 'Failed to add to cart'
      );
    }
  }
);

// Remove item

export const removeFromCart = createAsyncThunk(
  'cart/removeFromCart',
  async ({ productID }, { dispatch, getState, rejectWithValue }) => {
    const prevCart = [...getState().cart.cart];

    //  Optimistic update
    dispatch(
      cartSlice.actions.rollback(
        prevCart.filter((i) => i.productID !== productID)
      )
    );

    try {
      const response = await httpClient.post('/cart/remove-from-cart', {
        productID,
        cartSessionID: getCartSessionId(),
      });

      if (!response.data?.success) {
        dispatch(cartSlice.actions.rollback(prevCart));
        return rejectWithValue('Failed to remove item');
      }

      await new Promise((resolve) => setTimeout(resolve, 500));
      const fetchResult = await dispatch(fetchCart()).unwrap();
      return fetchResult;
    } catch (error) {
      dispatch(cartSlice.actions.rollback(prevCart));
      return rejectWithValue(error.message);
    }
  }
);

// Update item quantity
export const updateCartItem = createAsyncThunk(
  'cart/updateCartItem',
  async (
    { productID, cartSessionID, quantity },
    { dispatch, rejectWithValue }
  ) => {
    try {
      const response = await httpClient.post('/cart/update-cart-item', {
        productID,
        cartSessionID,
        quantity,
      });

      if (!response.data?.success) {
        return rejectWithValue(
          response.data?.message || 'Failed to update item'
        );
      }

      // Refresh the cart after update
      dispatch(fetchCart());

      // return response.data;
      //  Preserve selectedPaymentPlan locally even if API doesn't return it
      return {
        ...response.data,
        quantity,
        paymentPlan: existingItem.paymentPlan,
      };
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to update item');
    }
  }
);

// Update cartitem(s) payment plan
export const updateCartItemPaymentPlan = createAsyncThunk(
  'cart/updateCartItemPaymentPlan',
  async ({ productID, selectedPaymentPlan }, { getState, rejectWithValue }) => {
    const state = getState();
    const existingItem = state.cart.cart.find(
      (item) => item.productID === productID
    );

    if (!existingItem) throw new Error('Item not found in cart');

    try {
      const response = await httpClient.post('/cart/update-payment-plan', {
        productID,
        selectedPaymentPlan,
        cartSessionID: getCartSessionId(),
      });

      if (!response.data?.success) {
        return rejectWithValue(
          response.data?.message || 'Failed to update payment plan'
        );
      }

      return {
        ...response.data,
        productID,
        selectedPaymentPlan,
        paymentPlan: selectedPaymentPlan,
      };
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to update payment plan');
    }
  }
);

// Transfer guest cart to user cart

export const transferGuestCartToUser = createAsyncThunk(
  'cart/transferGuestCartToUser',
  async (cartSessionID, { dispatch, rejectWithValue }) => {
    try {
      if (!cartSessionID) return rejectWithValue('No cart session ID found');

      const response = await httpClient.post('/cart/transfer-guest-cart', {
        cartSessionID,
      });

      if (!response.data?.success) {
        return rejectWithValue(
          response.data?.message || 'Failed to transfer cart'
        );
      }

      // Remove guest cart session ID after successful transfer
      localStorage.removeItem('cartSessionID');

      // Fetch updated cart for logged-in user
      await dispatch(fetchCart());

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

/* -------------------- SLICE -------------------- */

const initialState = {
  cart: [],
  status: 'idle',
  error: null,
  selectedPaymentPlan: 'monthly',
  cart_summary: { total_items: 0, total_quantity: 0, total_amount: 0 },
  loading: false,
};

const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    setSelectedPaymentPlan: (state, action) => {
      state.selectedPaymentPlan = action.payload;
    },

    setItemPaymentPlan: (state, action) => {
      const { productID, plan, paymentOptions } = action.payload;
      const item = state.cart.find((i) => i.productID === productID);
      if (!item || item.paymentPlan === plan) return;

      item.paymentPlan = plan;

      const paymentMap = {};
      for (const option of paymentOptions) {
        if (option.type) paymentMap[option.type] = option;
      }

      const option = paymentMap[plan];
      if (!option) return;

      item.paymentPlanDetails = {
        type: plan,
        amount: Number(option.amount || item.price),
        totalPrice: Number(option.amount || item.price) * (item.quantity || 1),
      };

      item.price = Number(option.amount || item.price);
      item.totalPrice = item.price * (item.quantity || 1);

      // Update summary
      state.cart_summary = {
        total_items: state.cart.length,
        total_quantity: state.cart.reduce(
          (sum, i) => sum + Number(i.quantity || 0),
          0
        ),
        total_amount: state.cart.reduce(
          (sum, i) => sum + Number(i.totalPrice || 0),
          0
        ),
      };
    },

    optimisticAdd: (state, action) => {
      const product = action.payload;
      const existing = state.cart.find(
        (item) => item.productID === product.productID
      );

      if (!existing) {
        state.cart.push({
          ...product,
          quantity: Number(product.quantity || 1),
          paymentPlan: 'monthly',
          paymentPlanDetails: product.selectedPaymentPlanDetails || {
            type: '',
            amount: Number(product.fairAppPrice || product.productPrice),
            totalPrice:
              Number(product.fairAppPrice || product.productPrice) *
              (product.quantity || 1),
          },
          price: Number(
            product.selectedPaymentPlanDetails.amount ||
              product.fairAppPrice ||
              product.productPrice
          ),
          totalPrice:
            Number(
              product.selectedPaymentPlanDetails.amount ||
                product.fairAppPrice ||
                product.productPrice
            ) * (product.quantity || 1),
        });
      }

      // Update summary
      state.cart_summary = {
        total_items: state.cart.length,
        total_quantity: state.cart.reduce(
          (sum, i) => sum + Number(i.quantity || 0),
          0
        ),
        total_amount: state.cart.reduce(
          (sum, i) => sum + Number(i.totalPrice || 0),
          0
        ),
      };
    },

    rollback: (state, action) => {
      state.cart = action.payload;
      state.cart_summary = {
        total_items: state.cart.length,
        total_quantity: state.cart.reduce(
          (sum, i) => sum + Number(i.quantity || 0),
          0
        ),
        total_amount: state.cart.reduce(
          (sum, i) => sum + Number(i.totalPrice || 0),
          0
        ),
      };
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchCart.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchCart.fulfilled, (state, action) => {
        state.status = 'succeeded';
        const cartData = action.payload.data?.cart || {};
        const serverSessionID = action.payload.data?.owner?.cartSessionID;
        if (serverSessionID) {
          localStorage.setItem('cartSessionID', serverSessionID);
        }

        if (cartData.items && cartData.items.length > 0) {
          state.cart = cartData.items.map((item) => {
            // Parse options safely
            const options = Array.isArray(item.paymentOptionsBreakdown)
              ? item.paymentOptionsBreakdown
              : JSON.parse(item.paymentOptionsBreakdown || '[]');

            // Normalize plan types
            const normalizedOptions = options.map((opt) =>
              String(opt?.type || '')
                .toLowerCase()
                .trim()
            );

            // Normalize the selected plan
            let validPlan = String(item.selectedPaymentPlan || '')
              .toLowerCase()
              .trim();

            // ✅ FIX: Ensure only valid plan remains
            if (!normalizedOptions.includes(validPlan)) {
              validPlan = normalizedOptions.includes('full')
                ? 'full'
                : normalizedOptions[0] || 'full';
            }

            return {
              ...item,
              paymentPlan: validPlan,
              selectedPaymentPlan: validPlan,
              price: Number(
                item.price || item.fairAppPrice || item.productPrice
              ),
              totalPrice:
                Number(item.price || item.fairAppPrice || item.productPrice) *
                (item.quantity || 1),
            };
          });

          state.cart_summary = cartData.summary || {
            total_items: 0,
            total_quantity: 0,
            total_amount: 0,
          };
        } else {
          state.cart = [];
          state.cart_summary = {
            total_items: 0,
            total_quantity: 0,
            total_amount: 0,
          };
        }
      })

      .addCase(fetchCart.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || 'Failed to fetch cart';
      })
      .addCase(addToCart.fulfilled, (state, action) => {
        state.status = 'succeeded';
        const cartData = action.payload.data?.cart || {};
        if (cartData.items && cartData.items.length > 0) {
          state.cart = cartData.items.map((item) => ({
            ...item,
            paymentPlan: item.paymentPlan,
            price: Number(item.price || item.fairAppPrice || item.productPrice),
            totalPrice:
              Number(item.price || item.fairAppPrice || item.productPrice) *
              (item.quantity || 1),
          }));
          state.cart_summary = cartData.summary || state.cart_summary;
        } else {
          // Retain optimistic state
          state.cart_summary = {
            total_items: state.cart.length,
            total_quantity: state.cart.reduce(
              (sum, i) => sum + Number(i.quantity || 0),
              0
            ),
            total_amount: state.cart.reduce(
              (sum, i) => sum + Number(i.totalPrice || 0),
              0
            ),
          };
        }
      })
      .addCase(removeFromCart.fulfilled, (state, action) => {
        state.status = 'succeeded';
        const cartData = action.payload?.data?.cart || {};
        state.cart = (cartData.items || []).map((item) => ({
          ...item,
          paymentPlan: item.paymentPlan || item.selectedPaymentPlan,
          price: Number(item.price || item.fairAppPrice || item.productPrice),
          totalPrice:
            Number(item.price || item.fairAppPrice || item.productPrice) *
            (item.quantity || 1),
        }));
        state.cart_summary = cartData.summary || state.cart_summary;
      })

      .addCase(updateCartItemPaymentPlan.fulfilled, (state, action) => {
        const { productID, selectedPaymentPlan, paymentPlan } = action.payload;

        const item = state.cart.find((i) => i.productID === productID);

        if (item) {
          // ✅ Update both fields
          item.selectedPaymentPlan = selectedPaymentPlan;
          item.paymentPlan = paymentPlan;
        }
      })
      .addCase(updateCartItemPaymentPlan.rejected, (state, action) => {
        console.error('Failed to update payment plan:', action.payload);
      });
  },
});

export const {
  setSelectedPaymentPlan,
  setItemPaymentPlan,
  optimisticAdd,
  rollback,
} = cartSlice.actions;

export const getCart = (state) => state?.cart?.cart;
export const getCartSummary = (state) => state.cart.cart_summary;

// export const getTotalCartQuantity = (state) => {
//   const cart = Array.isArray(state.cart.cart) ? state.cart.cart : [];
//   return cart.length;
// };

export const getTotalCartQuantity = (state) => {
  const cart = Array.isArray(state.cart.cart) ? state.cart.cart : [];
  return cart?.reduce((total, item) => total + (item.quantity || 0), 0);
};

export const getTotalCartPrice = (state) =>
  state?.cart?.cart?.reduce((sum, item) => sum + (item.totalPrice || 0), 0);

export const getCurrentQuantityById = (productID) => (state) =>
  state?.cart?.cart?.find((item) => item.productID === productID)?.quantity ??
  0;
export const getSelectedPaymentPlan = (state) => state.cart.selectedPaymentPlan;

export const getExistingCartItemById = (productID) => (state) =>
  state?.cart?.cart?.find((item) => item.productID === productID) || null;

export default cartSlice.reducer;
